import { createSelector } from "reselect"

import { iGet } from "../../utils/immutable"
import { brandingSelector } from "./selectors"

const optionsSelector = state => state.options

export const servicesSelector = createSelector(
  brandingSelector,
  iGet("services"),
)

const isEnabledInServices = service =>
  createSelector(
    optionsSelector,
    iGet(["branding", "services", service, "enabled"]),
  )

export const isInsuranceEnabledSelector = isEnabledInServices("insurance")
export const isGuaranteeEnabledSelector = isEnabledInServices("guarantee")
export const isWatchdogEnabledSelector = isEnabledInServices("watchdog")
export const isRefundEnabledSelector = isEnabledInServices("refunds")
export const isChangeFlightsEnabledSelector = isEnabledInServices("change_flights")
